import { render } from "./ImportCustomerData.vue?vue&type=template&id=aa8eadfc&scoped=true"
import script from "./ImportCustomerData.vue?vue&type=script&lang=js"
export * from "./ImportCustomerData.vue?vue&type=script&lang=js"

import "./ImportCustomerData.vue?vue&type=style&index=0&id=aa8eadfc&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8eadfc"]])

export default __exports__